import React, { Component, PropTypes } from 'react';

class ReactSparkToggle extends Component {
    render() {
        return (
            <div className="row spark-toggle-group">
                {this.props.values.map(value => (
                    <label className="spark-toggle" name={this.props.name} key={value.key}>
                        <input
                            className="spark-toggle__input"
                            type="radio"
                            value={value.key}
                            checked={this.props.selected === value.key}
                            onChange={this.props.onChange}
                        />
                        <span className="spark-label">{value.label}</span>
                    </label>
                ))}
            </div>
        );
    }
}

ReactSparkToggle.propTypes = {
    name: PropTypes.string,
    selected: PropTypes.string,
    values: PropTypes.array,
    onChange: PropTypes.func
};

export default ReactSparkToggle;



// WEBPACK FOOTER //
// ./src/components/widgets/ReactSparkToggle.js